(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.homePageAnimations = {
    attach: function(context, settings) {
      let winDebounce = null;
      //Homepage sustainability panel can animation
      /*global ScrollMagic, TweenMax, Linear */


      const scrollMagicHomepage = function() {
        const controller = new ScrollMagic.Controller();
        const globalHeader = document.querySelector('.global-header');
        const hpHeroWrapper = document.querySelector('#hp-hero-wrapper');
        // World Environment Day (WED) -- comment out below
        const video = hpHeroWrapper.querySelector('video');
        const reduceMotion = jQuery('body').hasClass('reduce-motion');

        jQuery(hpHeroWrapper).find('.hp-hero-full-motion #hp-hero-content').css({'top': jQuery(globalHeader).outerHeight(true)});

        // Rotating Can Animation

        var rotateCircleAnim = TweenMax.to('.hp-sustainability-panel .field--name-field-animated-can img', 0.5, {rotation: 230, ease: Linear.easeNone});
        var rotateCircle = new ScrollMagic.Scene({
          triggerElement: '.hp-sustainability-panel',
          duration: 1700,
          offset: 300});
        rotateCircle.setPin('.hp-sustainability-panel .field--name-field-animated-can img', {pushFollowers: false});
        rotateCircle.setTween(rotateCircleAnim);
        rotateCircle.addTo(controller);
        rotateCircle.on('start enter update', e => {
          window.blazy.revalidate();
          jQuery('.hp-sustainability-panel .field--name-field-animated-can img').css({'padding-bottom': '', 'height': ''});
        });

        if (!reduceMotion && !window.homeAnimations && jQuery('.hp-sustainability-panel').length > 0) {
          window.homeAnimations = true;

          // attach the animations

          const heroTextAnim = TweenMax.fromTo('.hp-hero-full-motion #hp-hero-text-row', 2, {x: 0}, {x: '-100vw'});
          const heroText = new ScrollMagic.Scene({
            duration: 1600,
            offset: 500,
            triggerElement: hpHeroWrapper,
            triggerHook: 0
          });
          heroText.setTween(heroTextAnim);
          heroText.addTo(controller);

          const heroBullet1Anim = TweenMax.fromTo('.hp-hero-full-motion #hp-hero-link-1', 3, { opacity: 1 }, { opacity: 0 });
          let heroBullet1 = new ScrollMagic.Scene({
            duration: 1000,
            triggerElement: hpHeroWrapper,
            triggerHook: 0,
            offset: 0
          });
          heroBullet1.setTween(heroBullet1Anim);
          heroBullet1.addTo(controller);

          const heroPad2Anim = TweenMax.fromTo('.hp-hero-full-motion #hp-hero-item-container-2', 3, { x: '50%' }, { x: 0 });
          let heroPad2 = new ScrollMagic.Scene({
            duration: 1500,
            triggerElement: hpHeroWrapper,
            offset: 500,
            triggerHook: 0
          });
          heroPad2.setTween(heroPad2Anim);
          heroPad2.addTo(controller);

          const heroBullet2Anim = TweenMax.fromTo('.hp-hero-full-motion #hp-hero-link-2', 3, { opacity: 0 }, { opacity: 1 });
          let heroBullet2 = new ScrollMagic.Scene({
            duration: 1000,
            triggerElement: hpHeroWrapper,
            offset: 500,
            triggerHook: 0
          });
          heroBullet2.setTween(heroBullet2Anim);
          heroBullet2.addTo(controller);

          const mobileCanAnim = TweenMax.fromTo('.hp-hero-full-motion .color-can', 3, { opacity: 0 }, { opacity: 1 });
          const heroMobileCan = new ScrollMagic.Scene({
            duration: 2000,
            triggerElement: hpHeroWrapper,
            triggerHook: 0
          });
          heroMobileCan.setTween(mobileCanAnim);
          heroMobileCan.addTo(controller);
          heroMobileCan.on('start enter', e => {
            window.blazy.revalidate();
          });

          // World Environment Day (WED) -- comment out below
          let sceneCanVideo = new ScrollMagic.Scene({
            duration: 2000,
            triggerElement: hpHeroWrapper,
            triggerHook: 0
          });
          sceneCanVideo.setPin(hpHeroWrapper);
          sceneCanVideo.addTo(controller);

          //Video Animation
          let canVideoPosition = 0;

          sceneCanVideo.on('update', e => {
            canVideoPosition = e.scrollPos / 500;
            video.currentTime = canVideoPosition;
          });

          sceneCanVideo.on('enter', e => {
            jQuery(globalHeader).addClass('visible');
          });
          sceneCanVideo.on('leave', e => {
            jQuery(globalHeader).removeClass('visible');
          });
        }
      };

      jQuery(document).ready(function() {
        scrollMagicHomepage();
      });

      jQuery(window).resize(function() {
        winDebounce = setTimeout(function() {
          clearTimeout(winDebounce);
          scrollMagicHomepage();
        }, 200);
      });
    }
  };
})(jQuery, Drupal);
